import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { ContributoUnificatoAddComponent } from './sezione-economica-contributo-unificato-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-add-contributo-unificato]',
  templateUrl: 'sezione-economica-mod-add-contributo-unificato.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ModContributoUnificatoAddComponent {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  isFs: boolean = PropertiesSettings.ID_TENANTS_FS();
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formContributoUnificatoAdd') formContributoUnificatoAdd: ContributoUnificatoAddComponent;

  inizializza(sezione: SezioneEconomica, fascicolo: FascicoloFull, urlInsert: string, recuperoCrediti: boolean = false) {
    openModal('modaleContributoUnificatoAdd');
      this.formContributoUnificatoAdd.inizializza(sezione, fascicolo, urlInsert, recuperoCrediti);
  }

  createForm() {
      this.formContributoUnificatoAdd.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleContributoUnificatoAdd');
      this.onReturn.emit(sezioneEconomica);
  }
}
